import App from './App.svelte';

window.uriValue = function(val) {
	let match = `${document.location.href}&`.match(new RegExp(`${val}=(.*?)\&`))
	if (typeof match !== 'undefined' && match !== null && match.length > 1) return match[1]
}

window.sleep = async function sleep(delay=1000) { return new Promise((resolve,reject) => { setTimeout(() => { resolve(true); }, delay); }); }

/**
 * backend api request
 * @param {*} data 
 */
window.backend = async function(data,attr={}) {
	let props = {
		method: 'POST',
		cache: 'no-cache',
		mode: 'cors',
		headers: { 'Content-Type': 'application/json' },
		redirect: 'follow',
		referrerPolicy: 'no-referrer',
		body: JSON.stringify(data)
	}
	attr.attempt = 0
	attr.attemptsMax = attr.attemptsMax ?? 10
	attr.error = undefined
	do {
		try {
			let result = await fetch( ( document.location.href.indexOf('/dev/') > -1 ?'/dev':'') + '/api/web/session',props);
			let json = await result.json();
			if (typeof json.error !== 'undefined') throw new Error(json.error);
			return json;		
		} catch(err) {
			attr.error = err
		}
		attr.attempt++;
		await sleep(5000)
	} while (attr.attempt <= attr.attemptsMax)
	throw attr.error
}

/**
 * Svelte initialize
 */
 const app = new App({
	target: document.body
});
window.app = app;
export default app;